<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1">CONTENTS</h1>
<nav epub:type="toc" id="toc">
<ol class="tocol">
<li class="table-of-content">
<a href="#/0_chapter1thereincarnationofarebornstar">CHAPTER 1 - THE REINCARNATION OF A REBORN STAR?</a>
</li>
<li class="table-of-content">
<a href="#/1_chapter2birth">CHAPTER 2 - BIRTH</a>
</li>
<li class="table-of-content">
<a href="#/2_chapter3capitalmeasurement">CHAPTER 3 - CAPITAL MEASUREMENT</a>
</li>
<li class="table-of-content">
<a href="#/3_chapter4alteringmusclemeridian">CHAPTER 4 - ALTERING MUSCLE MERIDIAN</a>
</li>
<li class="table-of-content">
<a href="#/4_chapter5acupunctureandmoxibustionneedlingpoint">CHAPTER 5 - ACUPUNCTURE AND MOXIBUSTION NEEDLING POINT</a>
</li>
<li class="table-of-content">
<a href="#/5_chapter6xuanyuanzhen">CHAPTER 6 - XUANYUAN ZHEN</a>
</li>
<li class="table-of-content">
<a href="#/6_chapter7enemieshaveanarrowroad">CHAPTER 7 - ENEMIES HAVE A NARROW ROAD</a>
</li>
<li class="table-of-content">
<a href="#/7_chapter8tibetanmeridianpavilion">CHAPTER 8 - TIBETAN MERIDIAN PAVILION</a>
</li>
<li class="table-of-content">
<span href="#/8_chapter9hunting" title="Link target outside of Sample">CHAPTER 9 - HUNTING</span>
</li>
<li class="table-of-content">
<span href="#/9_chapter10nangongxiner" title="Link target outside of Sample">CHAPTER 10 - NANGONG XIN'ER</span>
</li>
<li class="table-of-content">
<span href="#/10_chapter11gradefiveviciousbeast" title="Link target outside of Sample">CHAPTER 11 - GRADE FIVE VICIOUS BEAST</span>
</li>
<li class="table-of-content">
<span href="#/11_chapter12thebattlebetweenthefifthlevelviciousbeasts" title="Link target outside of Sample">CHAPTER 12 - THE BATTLE BETWEEN THE FIFTH LEVEL VICIOUS BEASTS</span>
</li>
<li class="table-of-content">
<span href="#/12_chapter13themantisstalksthecicadaandtheoriole" title="Link target outside of Sample">CHAPTER 13 - THE MANTIS STALKS THE CICADA AND THE ORIOLE</span>
</li>
<li class="table-of-content">
<span href="#/13_chapter14counterattack" title="Link target outside of Sample">CHAPTER 14 - COUNTERATTACK</span>
</li>
<li class="table-of-content">
<span href="#/14_chapter15thousandyearsoldcinnabarfruit" title="Link target outside of Sample">CHAPTER 15 - THOUSAND YEARS OLD CINNABAR FRUIT</span>
</li>
<li class="table-of-content">
<span href="#/15_chapter16wuqingluo" title="Link target outside of Sample">CHAPTER 16 - WU QINGLUO</span>
</li>
<li class="table-of-content">
<span href="#/16_chapter17auction" title="Link target outside of Sample">CHAPTER 17 - AUCTION</span>
</li>
<li class="table-of-content">
<span href="#/17_chapter18pleasecherish" title="Link target outside of Sample">CHAPTER 18 - PLEASE CHERISH</span>
</li>
<li class="table-of-content">
<span href="#/18_chapter19annualsession" title="Link target outside of Sample">CHAPTER 19 - ANNUAL SESSION</span>
</li>
<li class="table-of-content">
<span href="#/19_chapter20yangyan" title="Link target outside of Sample">CHAPTER 20 - YANG YAN</span>
</li>
<li class="table-of-content">
<span href="#/20_chapter21annuallargecompetition" title="Link target outside of Sample">CHAPTER 21 - ANNUAL LARGE COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/21_chapter22qinger" title="Link target outside of Sample">CHAPTER 22 - QING'ER</span>
</li>
<li class="table-of-content">
<span href="#/22_chapter23strike" title="Link target outside of Sample">CHAPTER 23 - STRIKE</span>
</li>
<li class="table-of-content">
<span href="#/23_chapter24fightluohua" title="Link target outside of Sample">CHAPTER 24 - FIGHT LUO HUA</span>
</li>
<li class="table-of-content">
<span href="#/24_chapter25realstrength" title="Link target outside of Sample">CHAPTER 25 - REAL STRENGTH</span>
</li>
<li class="table-of-content">
<span href="#/25_chapter26firstinthelargecompetition" title="Link target outside of Sample">CHAPTER 26 - FIRST IN THE LARGE COMPETITION</span>
</li>
<li class="table-of-content">
<span href="#/26_chapter27reentryintothescripturepavilion" title="Link target outside of Sample">CHAPTER 27 - REENTRY INTO THE SCRIPTURE PAVILION</span>
</li>
<li class="table-of-content">
<span href="#/27_chapter28flamedevouringbodyrefiningtechnique" title="Link target outside of Sample">CHAPTER 28 - FLAME DEVOURING BODY REFINING TECHNIQUE</span>
</li>
<li class="table-of-content">
<span href="#/28_chapter29blackeggmutation" title="Link target outside of Sample">CHAPTER 29 - BLACK EGG MUTATION</span>
</li>
<li class="table-of-content">
<span href="#/29_chapter30askedtofightautumnmoon" title="Link target outside of Sample">CHAPTER 30 - ASKED TO FIGHT AUTUMN MOON</span>
</li>
<li class="table-of-content">
<span href="#/30_chapter31stagefright" title="Link target outside of Sample">CHAPTER 31 - STAGE FRIGHT?</span>
</li>
<li class="table-of-content">
<span href="#/31_chapter32forcingtheduoprides" title="Link target outside of Sample">CHAPTER 32 - FORCING THE DUO PRIDES</span>
</li>
<li class="table-of-content">
<span href="#/32_chapter33stunningfourseals" title="Link target outside of Sample">CHAPTER 33 - STUNNING FOUR SEALS</span>
</li>
<li class="table-of-content">
<span href="#/33_chapter34hisnameshooktheentirebailu" title="Link target outside of Sample">CHAPTER 34 - HIS NAME SHOOK THE ENTIRE BAILU.</span>
</li>
<li class="table-of-content">
<span href="#/34_chapter35strangeblackegg" title="Link target outside of Sample">CHAPTER 35 - STRANGE BLACK EGG</span>
</li>
<li class="table-of-content">
<span href="#/35_chapter36fireseed" title="Link target outside of Sample">CHAPTER 36 - FIRE SEED</span>
</li>
<li class="table-of-content">
<span href="#/36_chapter37assaultandkilling" title="Link target outside of Sample">CHAPTER 37 - ASSAULT AND KILLING</span>
</li>
<li class="table-of-content">
<span href="#/37_chapter38bloodspiritmonkey" title="Link target outside of Sample">CHAPTER 38 - BLOOD SPIRIT MONKEY</span>
</li>
<li class="table-of-content">
<span href="#/38_chapter39monkeyking" title="Link target outside of Sample">CHAPTER 39 - MONKEY KING</span>
</li>
<li class="table-of-content">
<span href="#/39_chapter40tentativewindandrain" title="Link target outside of Sample">CHAPTER 40 - TENTATIVE WIND AND RAIN</span>
</li>
<li class="table-of-content">
<span href="#/40_chapter41undercurrentsurge" title="Link target outside of Sample">CHAPTER 41 - UNDERCURRENT SURGE</span>
</li>
<li class="table-of-content">
<span href="#/41_chapter42dyingstruggle" title="Link target outside of Sample">CHAPTER 42 - DYING STRUGGLE</span>
</li>
<li class="table-of-content">
<span href="#/42_chapter43fistintent" title="Link target outside of Sample">CHAPTER 43 - FIST INTENT</span>
</li>
<li class="table-of-content">
<span href="#/43_chapter44warmkilling" title="Link target outside of Sample">CHAPTER 44 - WARM KILLING</span>
</li>
<li class="table-of-content">
<span href="#/44_chapter45bloodsplatteredmandarinduckhouse" title="Link target outside of Sample">CHAPTER 45 - BLOOD SPLATTERED MANDARIN DUCK HOUSE</span>
</li>
<li class="table-of-content">
<span href="#/45_chapter46seeingamountainisnotamountain" title="Link target outside of Sample">CHAPTER 46 - SEEING A MOUNTAIN IS NOT A MOUNTAIN</span>
</li>
<li class="table-of-content">
<span href="#/46_chapter47perfectionofmovement" title="Link target outside of Sample">CHAPTER 47 - PERFECTION OF MOVEMENT</span>
</li>
<li class="table-of-content">
<span href="#/47_chapter48theterrifyinggradenineviciousbeast" title="Link target outside of Sample">CHAPTER 48 - THE TERRIFYING GRADE NINE VICIOUS BEAST …</span>
</li>
<li class="table-of-content">
<span href="#/48_chapter49coriolinafructus" title="Link target outside of Sample">CHAPTER 49 - CORIOLINA, FRUCTUS</span>
</li>
<li class="table-of-content">
<span href="#/49_chapter50crossingtheheavenlytribulation" title="Link target outside of Sample">CHAPTER 50 - CROSSING THE HEAVENLY TRIBULATION!</span>
</li>
<li class="table-of-content">
<span href="#/50_chapter51mutation" title="Link target outside of Sample">CHAPTER 51 - MUTATION</span>
</li>
<li class="table-of-content">
<span href="#/51_chapter52flooddragon" title="Link target outside of Sample">CHAPTER 52 - FLOOD DRAGON</span>
</li>
<li class="table-of-content">
<span href="#/52_chapter53hatching" title="Link target outside of Sample">CHAPTER 53 - HATCHING</span>
</li>
<li class="table-of-content">
<span href="#/53_chapter54phoenix" title="Link target outside of Sample">CHAPTER 54 - PHOENIX?</span>
</li>
<li class="table-of-content">
<span href="#/54_chapter55breakoutcrow" title="Link target outside of Sample">CHAPTER 55 - BREAK OUT, CROW?</span>
</li>
<li class="table-of-content">
<span href="#/55_chapter56lucifera" title="Link target outside of Sample">CHAPTER 56 - LUCIFERA</span>
</li>
<li class="table-of-content">
<span href="#/56_chapter57tianji" title="Link target outside of Sample">CHAPTER 57 - TIAN JI</span>
</li>
<li class="table-of-content">
<span href="#/57_chapter58achaoticworldisabouttobreakout" title="Link target outside of Sample">CHAPTER 58 - A CHAOTIC WORLD IS ABOUT TO BREAK OUT</span>
</li>
<li class="table-of-content">
<span href="#/58_chapter59thunderflamebodyrefinement" title="Link target outside of Sample">CHAPTER 59 - THUNDER FLAME BODY REFINEMENT</span>
</li>
<li class="table-of-content">
<span href="#/59_chapter60breakthroughflamesea" title="Link target outside of Sample">CHAPTER 60 - BREAKTHROUGH, FLAME SEA</span>
</li>
<li class="table-of-content">
<span href="#/60_chapter61savethemonkeyking" title="Link target outside of Sample">CHAPTER 61 - SAVE THE MONKEY KING</span>
</li>
<li class="table-of-content">
<span href="#/61_chapter62detoxification" title="Link target outside of Sample">CHAPTER 62 - DETOXIFICATION</span>
</li>
<li class="table-of-content">
<span href="#/62_chapter63calmnessofwindandrain" title="Link target outside of Sample">CHAPTER 63 - CALMNESS OF WIND AND RAIN</span>
</li>
<li class="table-of-content">
<span href="#/63_chapter64monkeywine" title="Link target outside of Sample">CHAPTER 64 - MONKEY WINE</span>
</li>
<li class="table-of-content">
<span href="#/64_chapter65fivebirdbodyforgingtechnique" title="Link target outside of Sample">CHAPTER 65 - FIVE-BIRD BODY FORGING TECHNIQUE</span>
</li>
<li class="table-of-content">
<span href="#/65_chapter66besieged" title="Link target outside of Sample">CHAPTER 66 - BESIEGED</span>
</li>
<li class="table-of-content">
<span href="#/66_chapter67battleoftheninestages" title="Link target outside of Sample">CHAPTER 67 - BATTLE OF THE NINE STAGES</span>
</li>
<li class="table-of-content">
<span href="#/67_chapter68battleconsciousness" title="Link target outside of Sample">CHAPTER 68 - BATTLE CONSCIOUSNESS</span>
</li>
<li class="table-of-content">
<span href="#/68_chapter69thunderflamebeastfire" title="Link target outside of Sample">CHAPTER 69 - THUNDER FLAME BEAST FIRE</span>
</li>
<li class="table-of-content">
<span href="#/69_chapter70lineoflifeanddeath" title="Link target outside of Sample">CHAPTER 70 - LINE OF LIFE AND DEATH</span>
</li>
<li class="table-of-content">
<span href="#/70_chapter71mercenarygroup" title="Link target outside of Sample">CHAPTER 71 - MERCENARY GROUP</span>
</li>
<li class="table-of-content">
<span href="#/71_chapter72quirkygreatbow" title="Link target outside of Sample">CHAPTER 72 - QUIRKY GREAT BOW</span>
</li>
<li class="table-of-content">
<span href="#/72_chapter73octagonaniseed" title="Link target outside of Sample">CHAPTER 73 - OCTAGON ANISEED</span>
</li>
<li class="table-of-content">
<span href="#/73_chapter74skycavern" title="Link target outside of Sample">CHAPTER 74 - SKY CAVERN</span>
</li>
<li class="table-of-content">
<span href="#/74_chapter75convergence" title="Link target outside of Sample">CHAPTER 75 - CONVERGENCE</span>
</li>
<li class="table-of-content">
<span href="#/75_chapter76dreadfulskycavern" title="Link target outside of Sample">CHAPTER 76 - DREADFUL SKY CAVERN</span>
</li>
<li class="table-of-content">
<span href="#/76_chapter77luoyuwentdowntheskycavern" title="Link target outside of Sample">CHAPTER 77 - LUO YU WENT DOWN THE SKY CAVERN.</span>
</li>
<li class="table-of-content">
<span href="#/77_chapter78firebat" title="Link target outside of Sample">CHAPTER 78 - FIRE BAT</span>
</li>
<li class="table-of-content">
<span href="#/78_chapter79qingerwasindanger" title="Link target outside of Sample">CHAPTER 79 - QING'ER WAS IN DANGER</span>
</li>
<li class="table-of-content">
<span href="#/79_chapter80yourenothuman" title="Link target outside of Sample">CHAPTER 80 - YOU'RE NOT HUMAN!</span>
</li>
<li class="table-of-content">
<span href="#/80_chapter81aurapressure" title="Link target outside of Sample">CHAPTER 81 - AURA PRESSURE</span>
</li>
<li class="table-of-content">
<span href="#/81_chapter82psychicbodywithsevenapertures" title="Link target outside of Sample">CHAPTER 82 - PSYCHIC BODY WITH SEVEN APERTURES</span>
</li>
<li class="table-of-content">
<span href="#/82_chapter83thethirdstageofinnate" title="Link target outside of Sample">CHAPTER 83 - THE THIRD STAGE OF INNATE</span>
</li>
<li class="table-of-content">
<span href="#/83_chapter84sheepnoitwasthewolf" title="Link target outside of Sample">CHAPTER 84 - SHEEP? NO, IT WAS THE WOLF!</span>
</li>
<li class="table-of-content">
<span href="#/84_chapter85imsorry" title="Link target outside of Sample">CHAPTER 85 - I'M SORRY!</span>
</li>
<li class="table-of-content">
<span href="#/85_chapter86azuredragonking" title="Link target outside of Sample">CHAPTER 86 - AZURE DRAGON KING</span>
</li>
<li class="table-of-content">
<span href="#/86_chapter87departureofawomanonadragon" title="Link target outside of Sample">CHAPTER 87 - DEPARTURE OF A WOMAN ON A DRAGON</span>
</li>
<li class="table-of-content">
<span href="#/87_chapter88renyu" title="Link target outside of Sample">CHAPTER 88 - REN YU</span>
</li>
<li class="table-of-content">
<span href="#/88_chapter89deep" title="Link target outside of Sample">CHAPTER 89 - DEEP</span>
</li>
<li class="table-of-content">
<span href="#/89_chapter90crimsonfiredevilbat" title="Link target outside of Sample">CHAPTER 90 - CRIMSON FIRE DEVIL BAT</span>
</li>
<li class="table-of-content">
<span href="#/90_chapter91wardemonicbeast" title="Link target outside of Sample">CHAPTER 91 - WAR DEMONIC BEAST</span>
</li>
<li class="table-of-content">
<span href="#/91_chapter92tequilashowingitsmight" title="Link target outside of Sample">CHAPTER 92 - TEQUILA SHOWING ITS MIGHT</span>
</li>
<li class="table-of-content">
<span href="#/92_chapter93excavation" title="Link target outside of Sample">CHAPTER 93 - EXCAVATION</span>
</li>
<li class="table-of-content">
<span href="#/93_chapter94harvestleave" title="Link target outside of Sample">CHAPTER 94 - HARVEST, LEAVE</span>
</li>
<li class="table-of-content">
<span href="#/94_chapter95touch" title="Link target outside of Sample">CHAPTER 95 - TOUCH</span>
</li>
<li class="table-of-content">
<span href="#/95_chapter96thousandmenfighting" title="Link target outside of Sample">CHAPTER 96 - THOUSAND MEN FIGHTING</span>
</li>
<li class="table-of-content">
<span href="#/96_chapter97bloodfighting" title="Link target outside of Sample">CHAPTER 97 - BLOOD-FIGHTING</span>
</li>
<li class="table-of-content">
<span href="#/97_chapter98bloodyruthlessness" title="Link target outside of Sample">CHAPTER 98 - BLOODY RUTHLESSNESS</span>
</li>
<li class="table-of-content">
<span href="#/98_chapter99themightofthewarbeast" title="Link target outside of Sample">CHAPTER 99 - THE MIGHT OF THE WARBEAST</span>
</li>
<li class="table-of-content">
<span href="#/99_chapter100hehadtosuppresstheentireaudiencewithforce" title="Link target outside of Sample">CHAPTER 100 - HE HAD TO SUPPRESS THE ENTIRE AUDIENCE WITH FORCE!</span>
</li>
</ol>
</nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?4ed2f8b8